export const ovgDetail = (state) => state.ovgDetail
